import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { HashLink } from "react-router-hash-link";
import style from "./Header.module.css";
import logo from "../../../assets/img/logo_sinBajada.png";

const Header = ({ isMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const submenuRef = useRef(null);

  const isActive = (path) => {
    return location.pathname + location.hash === path ? style.sales : "";
  };

  // Cierra el submenú desktop al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (submenuRef.current && !submenuRef.current.contains(e.target)) {
        setSubmenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={style.header} id="top">
      {isMobile ? (
        <div className={style.headerMobile}>
          <div className={style.headerContent}>
            <h1 onClick={() => navigate("/")}>
              <img src={logo} alt="Electroplat" />
            </h1>
            <div
              className={style.mobileMenu}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <div className={style.bar}></div>
              <div className={style.bar}></div>
              <div className={style.bar}></div>
            </div>
          </div>

          {menuOpen ? (
            <ul>
              <li
                onClick={() => setMenuOpen(false)}
                className={isActive("/#top")}
              >
                <HashLink smooth to="/#top">Inicio</HashLink>
              </li>
              <li
                onClick={() => setMenuOpen(false)}
                className={isActive("/#about")}
              >
                <HashLink smooth to="/#about">Nosotros</HashLink>
              </li>
              <li
                onClick={() => setMenuOpen(false)}
                className={isActive("/#brands")}
              >
                <HashLink smooth to="/#brands">Marcas</HashLink>
              </li>
              <li
                onClick={() => setMenuOpen(false)}
                className={isActive("/#contact")}
              >
                <HashLink smooth to="/#contact">Contacto</HashLink>
              </li>

              {/* Productos con submenú en mobile */}
              <li
                className={style.hasSubmenuMobile}
                onClick={() => setSubmenuOpen(!submenuOpen)}
              >
                Productos
              </li>
              {submenuOpen && (
                <ul className={style.submenuMobile}>
                  <li onClick={() => {
                    setMenuOpen(false);
                    navigate("/productos")
                  }}>
                    <HashLink smooth to="/productos">Clásicos</HashLink>
                  </li>
                  <li onClick={() => {
                    setMenuOpen(false);
                    navigate("/ofertas")
                  }}>
                    <HashLink smooth to="/ofertas">Ofertas</HashLink>
                  </li>
                  <li onClick={() => {
                    setMenuOpen(false);
                    navigate("/novedades")
                  }}>
                    <HashLink smooth to="/novedades">Novedades</HashLink>
                  </li>
                </ul>
              )}
            </ul>
          ) : null}
        </div>
      ) : (
        <div className={style.headerContent}>
          <h1 onClick={() => navigate("/")}>
            <img src={logo} alt="Electroplat" />
          </h1>
          <ul>
            <li className={isActive("/#top")}>
              <HashLink smooth to="/#top">Inicio</HashLink>
            </li>
            <li className={isActive("/#about")}>
              <HashLink smooth to="/#about">Nosotros</HashLink>
            </li>
            <li className={isActive("/#brands")}>
              <HashLink smooth to="/#brands">Marcas</HashLink>
            </li>
            <li className={isActive("/#contact")}>
              <HashLink smooth to="/#contact">Contacto</HashLink>
            </li>

            {/* Productos con submenú en desktop */}
            <li
              ref={submenuRef}
              className={style.hasSubmenu}
              onClick={() => setSubmenuOpen(!submenuOpen)}
            >
              Productos
              {submenuOpen && (
                <ul className={style.submenu}>
                  <li onClick={() => navigate("/productos")}>
                    <HashLink smooth to="/productos">Clásicos</HashLink>
                  </li>
                  <li onClick={() => navigate("/ofertas")}>
                    <HashLink smooth to="/ofertas">Ofertas</HashLink>
                  </li>
                  <li onClick={() => navigate("/novedades")}>
                    <HashLink smooth to="/novedades">Novedades</HashLink>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Header;
